module.exports = __webpack_public_path__ + "static/media/no_notif.f93f02ca.svg";